// @ts-nocheck

import * as React from 'react'

// const= {
//     fillRule: 'evenodd',
//     clipRule: 'evenodd',
//     fill: '#FEA301',
// };
//
// const= {
//     fillRule: 'evenodd',
//     clipRule: 'evenodd',
//     fill: '#FECA00',
// };
//
// const= {
//     fillRule: 'evenodd',
//     clipRule: 'evenodd',
//     fill: '#FE9800',
// };
//
// const= {
//     fillRule: 'evenodd',
//     clipRule: 'evenodd',
//     fill: '#FE7C00',
// };

export const FirebaseIcon = React.memo((props: { className: string }) => (
    <svg
        className={props.className}
        viewBox="0 0 1024 1024"
        data-icon="firebase"
        height="1em"
        width="1em"
        aria-hidden="true"
        fill="currentColor"
    >
        <path
            fill="currentColor"
            d="M296.611,9.365c10.021,4.225,16.592,11.447,21.782,21.172
        c38.9,72.893,78.255,145.542,117.419,218.292c1.032,1.917,1.53,4.123,2.276,6.193c-18.13,2.777-25.502,17.383-32.37,31.242
        c-45.45,91.728-99.192,178.947-146.124,269.909c-22.267,43.158-43.961,86.8-68.776,128.638
        c-6.815,11.49-10.936,25.869-25.507,31.313c0.133-4.474-0.21-9.019,0.469-13.406c8.874-57.431,17.88-114.841,26.875-172.254
        c24.646-157.282,49.188-314.581,74.116-471.818c2.802-17.678,2.404-37.189,19.744-49.282
        C289.88,9.365,293.246,9.365,296.611,9.365z"
        />
        <path
            fill="currentColor"
            d="M145.166,820.438c1.213,0.369,2.427,0.739,3.639,1.104
        c-0.002-0.006,0.001,0.47,0.001,0.47c-1.213,0.598-2.427,1.194-3.64,1.791C145.166,822.682,145.166,821.561,145.166,820.438z"
        />
        <path
            fill="currentColor"
            d="M626.46,339.754c8.128,3.212,10.86-4.204,14.803-8.113
        c33.837-33.559,67.563-67.233,100.956-101.231c8.854-9.015,18.263-15.738,31.045-11.178c11.488,4.099,13.733,14.663,15.505,25.713
        c17.6,109.756,35.449,219.472,53.362,329.178c13.053,79.945,26.314,159.855,39.428,239.791c0.354,2.168,0.068,4.44,0.084,6.664
        c-3.029,2.451-8.582,2.304-8.354,8.109c0,0-0.109-0.511-0.116-0.516c-2.247-0.233-3.586,0.86-4.276,2.905
        c0,0,0.315-0.226,0.314-0.228c-6.147-0.518-11.865-0.261-13.445,7.453c0,0,0.306-0.314,0.301-0.317
        c-3.366-0.562-6.245-0.286-6.856,3.934c0,0,0.325-0.559,0.319-0.56c-1.435,0.982-2.863,1.967-4.291,2.951l0.24-0.165
        c-3.006-0.042-5.737,0.421-6.927,3.739c0,0,0.349-0.229,0.347-0.23c-8.744-0.113-16.731,1.136-19.906,11.051
        c0,0,0.146-0.28,0.14-0.287c-3.437-0.744-6.358-0.631-6.613,3.943c0,0,0.083-0.563,0.076-0.568
        c-2.229-0.209-3.584,0.871-4.299,2.896c0,0,0.308-0.215,0.306-0.217c-8.741-0.101-16.721,1.167-19.922,11.048
        c0,0,0.168-0.291,0.161-0.296c-3.433-0.728-6.354-0.6-6.644,3.947c0,0,0.11-0.572,0.104-0.577
        c-1.438,0.967-2.869,1.938-4.301,2.91c0,0,0.306-0.213,0.304-0.213c-8.735-0.099-16.692,1.209-19.949,11.022
        c0,0,0.188-0.292,0.183-0.297c-3.425-0.703-6.338-0.551-6.679,3.947c0,0,0.149-0.572,0.144-0.575
        c-1.439,0.968-2.873,1.938-4.306,2.912c0,0,0.298-0.202,0.296-0.202c-8.729-0.083-16.668,1.26-19.948,11.029
        c0,0,0.207-0.299,0.201-0.304c-3.418-0.688-6.334-0.527-6.698,3.95c0,0,0.166-0.57,0.159-0.575
        c-1.439,0.968-2.872,1.94-4.306,2.912c0,0,0.293-0.197,0.291-0.197c-8.724-0.079-16.638,1.31-19.963,11.017
        c0,0,0.226-0.301,0.219-0.306c-3.409-0.666-6.321-0.486-6.724,3.952c0,0,0.195-0.568,0.188-0.573
        c-1.441,0.971-2.874,1.945-4.309,2.918c0,0,0.287-0.192,0.286-0.193c-8.715-0.057-16.625,1.337-19.963,11.018
        c0,0,0.231-0.304,0.227-0.309c-3.406-0.657-6.31-0.46-6.752,3.943c0,0,0.102-0.284,0.096-0.292
        c-3.465-0.861-6.421-0.893-6.429,3.909c0,0-0.16-0.049-0.163-0.062c-10.266,0.158-19.369,2.409-23.694,13.216
        c0,0,0.115-0.52,0.108-0.522c-1.438,0.969-2.871,1.941-4.304,2.915l0.271-0.181c-10.853,1.154-21.462,2.749-26.41,14.59
        c0,0,0.038-0.246,0.031-0.253c-3.46-0.836-6.405-0.826-6.476,3.92c0,0-0.102-0.076-0.105-0.088
        c-10.261,0.209-19.34,2.546-23.778,13.221c0,0,0.067-0.258,0.061-0.267c-3.455-0.804-6.405-0.778-6.494,3.944
        c0,0-0.07-0.104-0.073-0.113c-3.402-1.626-6.511-0.551-9.462,1.151c-26.674,15.395-53.393,15.835-80.157,0.276
        c-3.98-2.315-8.211-3.216-12.763-2.732l0.274,0.179c-1.443-0.966-2.884-1.929-4.324-2.894c0,0,0.202,0.478,0.207,0.468
        c-3.038-10.107-11.105-11.207-19.848-11.095c0,0,0.332,0.228,0.331,0.227c-0.715-2.043-2.065-3.117-4.306-2.847
        c0,0,0.087,0.498,0.094,0.486c-0.258-4.635-3.191-4.692-6.629-3.89c0,0,0.143,0.25,0.146,0.242
        c-3.127-9.972-11.156-11.153-19.874-11.096c0,0,0.315,0.212,0.314,0.21c-1.443-0.953-2.886-1.904-4.327-2.855
        c0,0,0.183,0.501,0.188,0.491c-0.372-4.524-3.298-4.644-6.718-3.914c0,0,0.212,0.277,0.214,0.268
        c-2.82-8.439-8.779-11.231-17.208-9.577l0.148-1.158c0,0-0.316,1.125-0.306,1.112c-0.031-4.843-2.999-4.764-6.455-3.868
        c0,0,0.14,0.246,0.143,0.236c-0.488-4.398-3.396-4.586-6.795-3.924c0,0,0.261,0.289,0.263,0.281
        c-2.914-8.342-8.933-11.098-17.299-9.634l0.215-0.814c0,0-0.254,0.848-0.247,0.836c-0.156-4.73-3.116-4.724-6.56-3.899
        c0,0,0.22,0.265,0.222,0.255c-0.585-4.286-3.479-4.528-6.854-3.931c0,0,0.319,0.299,0.319,0.293
        c-1.553-7.754-7.298-7.971-13.434-7.484c0,0,0.33,0.226,0.329,0.223c-0.727-2.033-2.087-3.102-4.317-2.852
        c0,0,0.125,0.503,0.13,0.493c-0.299-4.597-3.229-4.682-6.664-3.903c0,0,0.174,0.255,0.177,0.245
        c-3.176-9.904-11.19-11.112-19.895-11.081c0,0,0.309,0.207,0.307,0.206c-1.443-0.955-2.885-1.908-4.328-2.861
        c0,0,0.208,0.503,0.213,0.493c-0.401-4.482-3.324-4.629-6.736-3.933c0,0,0.238,0.283,0.24,0.274
        c-2.867-8.396-8.851-11.179-17.259-9.587l0.076-1.433c0,0-0.189,1.423-0.179,1.41c-0.076-4.801-3.04-4.749-6.491-3.882
        c0,0,0.167,0.253,0.169,0.243c-0.526-4.359-3.429-4.563-6.819-3.919c0,0,0.272,0.292,0.274,0.286
        c-2.932-8.327-8.989-11.045-17.327-9.673l1.315-0.784c0,0-1.289,0.844-1.282,0.832c-0.217-4.68-3.177-4.698-6.613-3.906
        c0,0,0.255,0.274,0.256,0.265c-0.629-4.248-3.517-4.506-6.887-3.913c0,0,0.32,0.301,0.322,0.295
        c-1.561-7.727-7.299-7.959-13.424-7.495c0,0,0.325,0.22,0.324,0.219c-0.738-2.025-2.107-3.087-4.329-2.854
        c0,0,0.163,0.506,0.168,0.494c-0.337-4.559-3.28-4.646-6.698-3.919c0,0,0.309,0.282,0.311,0.274
        c-0.708-4.138-3.577-4.447-6.92-3.923c0,0,0.344,0.308,0.345,0.303c-1.658-7.584-7.347-7.892-13.444-7.461
        c0,0,0.302,0.201,0.301,0.199c-1.444-0.965-2.887-1.926-4.332-2.888c0,0,0.261,0.507,0.265,0.497
        c-0.477-4.426-3.385-4.595-6.789-3.896c0,0,0.227,0.285,0.229,0.276c-2.003-8.512-9.051-9.679-15.994-11
        c-0.051-2.253-0.102-4.506-0.153-6.759c1.153-1.191,2.309-2.385,3.462-3.576l-0.036,0.089c3.4-2.879,7.025-5.531,10.166-8.67
        C286.103,684.684,406.646,564.16,527.156,443.604c3.148-3.148,5.869-6.726,8.79-10.103c29.112-28.728,58.264-57.417,87.241-86.279
        C624.979,345.437,625.401,342.275,626.46,339.754z"
        />
        <path
            fill="currentColor"
            d="M626.46,339.754c-1.059,2.521-1.48,5.683-3.272,7.467
        c-28.978,28.862-58.129,57.551-87.246,86.277c-1.708-2.136-3.8-4.067-5.061-6.438c-21.956-41.37-43.44-82.998-65.903-124.088
        c-7.094-12.975-12.073-27.513-23.648-37.768c0.1-1.384,0.199-2.766,0.297-4.149c8.096-3.631,9.178-12.254,12.78-18.827
        c13.674-24.963,26.224-50.544,40.05-75.418c10.371-18.659,31.062-19.17,41.02-0.554
        C566.279,223.834,596.198,281.886,626.46,339.754z"
        />
        <path
            fill="currentColor"
            d="M441.626,261.056c-0.099,1.384-0.197,2.766-0.297,4.148
        c-16.15,30.062-32.547,59.993-48.405,90.209C341.678,453.064,290.7,550.855,239.468,648.515
        c-16.604,31.649-34.792,62.521-50.155,94.752c-11.233,23.562-28.541,44.247-33.96,70.57l0.036-0.089
        c-1.155,1.193-2.309,2.385-3.462,3.576c0.051,2.253,0.102,4.506,0.151,6.756c-0.122,0.761-0.148,1.528-0.081,2.299
        c-2.534-0.375-3.185-2.13-3.191-4.361c0-0.005-0.003-0.48-0.001-0.475c3.257-35.489,8.999-70.593,16.506-105.419
        c14.571-5.442,18.692-19.821,25.507-31.312c24.815-41.838,46.51-85.479,68.776-128.638
        c46.932-90.962,100.674-178.181,146.124-269.909c6.867-13.859,14.239-28.465,32.37-31.242
        C439.268,257.035,440.448,259.044,441.626,261.056z"
        />
        <path
            fill="currentColor"
            d="M461.16,999.013c4.552-0.483,8.783,0.417,12.763,2.732
        c26.764,15.559,53.483,15.118,80.157-0.276c2.951-1.702,6.06-2.777,9.462-1.151C527.138,1026.457,500.062,1026.108,461.16,999.013
        z"
        />
        <path
            fill="currentColor"
            d="M600.377,979.953c4.948-11.841,15.558-13.436,26.41-14.59
        C618.989,972.048,609.984,976.544,600.377,979.953z"
        />
        <path
            fill="currentColor"
            d="M630.711,963.151c4.325-10.807,13.429-13.058,23.694-13.216
        C647.516,956.154,639.478,960.308,630.711,963.151z"
        />
        <path
            fill="currentColor"
            d="M570.049,996.753c4.438-10.675,13.518-13.012,23.778-13.221
        C586.907,989.754,578.868,993.956,570.049,996.753z"
        />
        <path
            fill="currentColor"
            d="M728.044,909.128c3.28-9.77,11.219-11.112,19.948-11.029
        C742.336,903.57,735.561,907.018,728.044,909.128z"
        />
        <path
            fill="currentColor"
            d="M407.232,968.794c8.718-0.058,16.747,1.124,19.874,11.096
        C419.654,977.674,412.859,974.279,407.232,968.794z"
        />
        <path
            fill="currentColor"
            d="M292.815,904.842c8.705-0.031,16.719,1.177,19.895,11.081
        C305.242,913.732,298.467,910.295,292.815,904.842z"
        />
        <path
            fill="currentColor"
            d="M758.354,892.313c3.257-9.813,11.214-11.121,19.949-11.022
        C772.654,886.772,765.864,890.194,758.354,892.313z"
        />
        <path
            fill="currentColor"
            d="M697.729,925.931c3.325-9.707,11.239-11.096,19.963-11.017
        C712.029,920.38,705.245,923.819,697.729,925.931z"
        />
        <path
            fill="currentColor"
            d="M788.68,875.52c3.201-9.881,11.181-11.148,19.922-11.048
        C802.962,869.96,796.168,873.368,788.68,875.52z"
        />
        <path
            fill="currentColor"
            d="M667.427,942.746c3.338-9.681,11.248-11.074,19.963-11.018
        C681.71,937.167,674.943,940.637,667.427,942.746z"
        />
        <path
            fill="currentColor"
            d="M818.992,858.705c3.175-9.915,11.162-11.164,19.906-11.051
        C833.293,853.193,826.472,856.543,818.992,858.705z"
        />
        <path
            fill="currentColor"
            d="M437.47,985.671c8.743-0.112,16.81,0.987,19.848,11.095
        C449.872,994.551,443.079,991.167,437.47,985.671z"
        />
        <path
            fill="currentColor"
            d="M349.394,936.462c8.366-1.464,14.385,1.292,17.299,9.634
        C360.041,944.474,354.245,941.316,349.394,936.462z"
        />
        <path
            fill="currentColor"
            d="M151.998,826.379c-0.067-0.771-0.042-1.538,0.081-2.299
        c6.944,1.324,13.992,2.491,15.996,11.003C161.911,833.667,156.635,830.613,151.998,826.379z"
        />
        <path
            fill="currentColor"
            d="M265.252,889.435c8.409-1.592,14.392,1.19,17.259,9.587
        C275.89,897.392,270.082,894.291,265.252,889.435z"
        />
        <path
            fill="currentColor"
            d="M379.694,953.416c8.43-1.654,14.389,1.138,17.208,9.577
        C390.3,961.361,384.524,958.237,379.694,953.416z"
        />
        <path
            fill="currentColor"
            d="M234.955,872.468c8.338-1.372,14.396,1.346,17.327,9.673
        C245.627,880.494,239.803,877.354,234.955,872.468z"
        />
        <path
            fill="currentColor"
            d="M208.643,857.761c6.125-0.464,11.863-0.231,13.424,7.495
        C216.846,864.094,212.127,862.033,208.643,857.761z"
        />
        <path
            fill="currentColor"
            d="M178.4,840.894c6.097-0.431,11.786-0.123,13.444,7.461
        C186.613,847.219,181.903,845.142,178.4,840.894z"
        />
        <path
            fill="currentColor"
            d="M323.055,921.717c6.136-0.486,11.881-0.27,13.434,7.484
        C331.257,928.063,326.527,926.02,323.055,921.717z"
        />
        <path
            fill="currentColor"
            d="M855.766,838.303c1.58-7.714,7.298-7.971,13.445-7.453
        C865.747,835.169,861.019,837.211,855.766,838.303z"
        />
        <path
            fill="currentColor"
            d="M873.289,828.688c-0.229-5.806,5.324-5.658,8.354-8.109
        C882.674,827.214,877.491,827.443,873.289,828.688z"
        />
        <path
            fill="currentColor"
            d="M396.689,962.726c3.42-0.729,6.346-0.61,6.718,3.914
        C400.597,966.314,398.139,965.383,396.689,962.726z"
        />
        <path
            fill="currentColor"
            d="M721.547,912.774c0.364-4.478,3.28-4.638,6.698-3.95
        C726.859,911.575,724.352,912.426,721.547,912.774z"
        />
        <path
            fill="currentColor"
            d="M312.533,915.678c3.435-0.778,6.364-0.693,6.664,3.903
        C316.972,918.288,314.753,916.982,312.533,915.678z"
        />
        <path
            fill="currentColor"
            d="M373.082,949.502c3.456-0.896,6.424-0.975,6.455,3.868
        C377.379,952.088,375.229,950.795,373.082,949.502z"
        />
        <path
            fill="currentColor"
            d="M691.224,929.577c0.402-4.438,3.314-4.618,6.724-3.952
        C696.561,928.396,694.033,929.226,691.224,929.577z"
        />
        <path
            fill="currentColor"
            d="M654.568,949.998c0.008-4.802,2.964-4.771,6.429-3.909
        C658.857,947.398,656.713,948.698,654.568,949.998z"
        />
        <path
            fill="currentColor"
            d="M336.17,928.908c3.375-0.598,6.27-0.355,6.854,3.931
        C340.198,932.478,337.6,931.71,336.17,928.908z"
        />
        <path
            fill="currentColor"
            d="M342.802,932.584c3.444-0.824,6.404-0.831,6.56,3.899
        C347.17,935.192,344.986,933.889,342.802,932.584z"
        />
        <path
            fill="currentColor"
            d="M366.43,945.814c3.398-0.662,6.307-0.475,6.795,3.924
        C370.405,949.392,367.873,948.544,366.43,945.814z"
        />
        <path
            fill="currentColor"
            d="M660.901,946.381c0.442-4.403,3.346-4.601,6.752-3.943
        C666.264,945.225,663.713,946.028,660.901,946.381z"
        />
        <path
            fill="currentColor"
            d="M849.21,841.919c0.611-4.22,3.49-4.496,6.856-3.934
        C854.688,840.876,852.052,841.579,849.21,841.919z"
        />
        <path
            fill="currentColor"
            d="M838.552,847.885c1.189-3.318,3.921-3.781,6.927-3.739
        C844.071,847.064,841.355,847.556,838.552,847.885z"
        />
        <path
            fill="currentColor"
            d="M191.499,848.052c3.343-0.524,6.212-0.215,6.92,3.923
        C195.589,851.592,192.917,850.928,191.499,848.052z"
        />
        <path
            fill="currentColor"
            d="M198.108,851.7c3.418-0.727,6.361-0.64,6.698,3.919
        C202.569,854.321,200.339,853.01,198.108,851.7z"
        />
        <path
            fill="currentColor"
            d="M812.519,862.361c0.255-4.574,3.177-4.688,6.613-3.943
        C817.75,861.111,815.298,862.012,812.519,862.361z"
        />
        <path
            fill="currentColor"
            d="M167.845,834.807c3.403-0.699,6.312-0.53,6.789,3.896
        C172.369,837.41,170.106,836.108,167.845,834.807z"
        />
        <path
            fill="currentColor"
            d="M563.615,1000.431c0.089-4.723,3.039-4.748,6.494-3.944
        C567.949,997.807,565.783,999.117,563.615,1000.431z"
        />
        <path
            fill="currentColor"
            d="M221.745,864.961c3.37-0.593,6.257-0.335,6.887,3.913
        C225.809,868.501,223.183,867.773,221.745,864.961z"
        />
        <path
            fill="currentColor"
            d="M228.375,868.609c3.436-0.792,6.396-0.773,6.613,3.906
        C232.78,871.221,230.578,869.916,228.375,868.609z"
        />
        <path
            fill="currentColor"
            d="M782.197,879.171c0.289-4.547,3.211-4.675,6.644-3.947
        C787.454,877.932,784.985,878.821,782.197,879.171z"
        />
        <path
            fill="currentColor"
            d="M593.933,983.62c0.07-4.746,3.016-4.756,6.476-3.92
        C598.254,981.012,596.094,982.314,593.933,983.62z"
        />
        <path
            fill="currentColor"
            d="M252.008,881.854c3.39-0.645,6.293-0.44,6.819,3.919
        C256.006,885.424,253.454,884.601,252.008,881.854z"
        />
        <path
            fill="currentColor"
            d="M258.658,885.53c3.451-0.867,6.415-0.919,6.491,3.882
        C262.978,888.127,260.817,886.828,258.658,885.53z"
        />
        <path
            fill="currentColor"
            d="M751.858,895.964c0.341-4.498,3.254-4.65,6.679-3.947
        C757.153,894.756,754.654,895.612,751.858,895.964z"
        />
        <path
            fill="currentColor"
            d="M426.96,979.647c3.438-0.803,6.371-0.745,6.629,3.89
        C431.375,982.249,429.167,980.947,426.96,979.647z"
        />
        <path
            fill="currentColor"
            d="M282.272,898.747c3.412-0.696,6.335-0.55,6.736,3.933
        C286.188,902.352,283.72,901.421,282.272,898.747z"
        />
        <path
            fill="currentColor"
            d="M457.111,996.298c1.439,0.965,2.881,1.928,4.324,2.894
        C459.993,998.227,458.552,997.263,457.111,996.298z"
        />
        <path
            fill="currentColor"
            d="M433.495,983.051c2.24-0.271,3.591,0.804,4.306,2.847
        C436.366,984.949,434.932,983.999,433.495,983.051z"
        />
        <path
            fill="currentColor"
            d="M626.516,965.544c1.433-0.974,2.866-1.946,4.304-2.915
        C629.39,963.603,627.952,964.574,626.516,965.544z"
        />
        <path
            fill="currentColor"
            d="M403.219,966.148c1.441,0.951,2.884,1.902,4.327,2.855
        C406.105,968.053,404.662,967.1,403.219,966.148z"
        />
        <path
            fill="currentColor"
            d="M687.104,931.922c1.435-0.973,2.867-1.947,4.309-2.918
        C689.98,929.979,688.541,930.951,687.104,931.922z"
        />
        <path
            fill="currentColor"
            d="M319.067,919.088c2.23-0.25,3.59,0.818,4.317,2.852
        C321.946,920.991,320.506,920.039,319.067,919.088z"
        />
        <path
            fill="currentColor"
            d="M717.4,915.111c1.434-0.972,2.866-1.944,4.306-2.912
        C720.274,913.174,718.837,914.142,717.4,915.111z"
        />
        <path
            fill="currentColor"
            d="M288.794,902.187c1.443,0.953,2.885,1.906,4.328,2.861
        C291.682,904.097,290.237,903.142,288.794,902.187z"
        />
        <path
            fill="currentColor"
            d="M747.696,898.301c1.433-0.974,2.866-1.944,4.306-2.912
        C750.572,896.361,749.134,897.331,747.696,898.301z"
        />
        <path
            fill="currentColor"
            d="M778,881.504c1.432-0.973,2.862-1.943,4.301-2.91
        C780.871,879.566,779.437,880.535,778,881.504z"
        />
        <path
            fill="currentColor"
            d="M808.296,864.688c0.715-2.024,2.07-3.104,4.299-2.896
        C811.167,862.763,809.73,863.726,808.296,864.688z"
        />
        <path
            fill="currentColor"
            d="M204.638,855.125c2.222-0.232,3.591,0.829,4.329,2.854
        C207.525,857.027,206.081,856.076,204.638,855.125z"
        />
        <path
            fill="currentColor"
            d="M845.238,844.311c1.428-0.984,2.856-1.969,4.291-2.951
        C848.103,842.345,846.67,843.327,845.238,844.311z"
        />
        <path
            fill="currentColor"
            d="M174.369,838.205c1.444,0.962,2.887,1.923,4.332,2.888
        C177.258,840.131,175.813,839.168,174.369,838.205z"
        />
        <path
            fill="currentColor"
            d="M868.896,831.077c0.69-2.045,2.029-3.139,4.276-2.905
        C871.751,829.143,870.325,830.11,868.896,831.077z"
        />
        <path
            fill="currentColor"
            d="M155.353,813.837c5.419-26.323,22.727-47.009,33.96-70.57
        c15.363-32.23,33.551-63.103,50.155-94.752c51.232-97.659,102.21-195.451,153.457-293.102
        c15.858-30.216,32.254-60.147,48.405-90.209c11.575,10.256,16.554,24.794,23.648,37.769
        c22.463,41.09,43.948,82.718,65.903,124.088c1.261,2.371,3.353,4.302,5.061,6.438c-2.916,3.378-5.637,6.956-8.785,10.104
        C406.646,564.16,286.103,684.684,165.519,805.167C162.378,808.306,158.753,810.958,155.353,813.837z"
        />
        <path
            fill="currentColor"
            d="M151.927,817.324c1.153-1.191,2.307-2.383,3.462-3.576
        C154.235,814.939,153.08,816.133,151.927,817.324z"
        />
    </svg>
))
